/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

const u = undefined;

// tslint:disable-next-line: only-arrow-functions
function plural(n: number): number {
  if (n === 1) { return 1; }

  return 5;
}

// tslint:disable-next-line: no-default-export
export default [
  'es-PE',
  [['a. m.', 'p. m.'], u, u],
  u,
  [
    ['d', 'l', 'm', 'm', 'j', 'v', 's'], ['dom.', 'lun.', 'mar.', 'mié.', 'jue.', 'vie.', 'sáb.'],
    ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    ['DO', 'LU', 'MA', 'MI', 'JU', 'VI', 'SA']
  ],
  [
    ['D', 'L', 'M', 'M', 'J', 'V', 'S'], ['dom.', 'lun.', 'mar.', 'mié.', 'jue.', 'vie.', 'sáb.'],
    ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    ['DO', 'LU', 'MA', 'MI', 'JU', 'VI', 'SA']
  ],
  [
    ['E', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
    [
      'ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'set.', 'oct.', 'nov.', 'dic.'
    ],
    [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'setiembre',
      'octubre', 'noviembre', 'diciembre'
    ]
  ],
  [
    ['E', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
    [
      'Ene.', 'Feb.', 'Mar.', 'Abr.', 'May.', 'Jun.', 'Jul.', 'Ago.', 'Set.', 'Oct.', 'Nov.', 'Dic.'
    ],
    [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre',
      'Octubre', 'Noviembre', 'Diciembre'
    ]
  ],
  [['a. C.', 'd. C.'], u, ['antes de Cristo', 'después de Cristo']],
  0,
  [6, 0],
  ['d/MM/yy', 'd MMM y', 'd \'de\' MMMM \'de\' y', 'EEEE, d \'de\' MMMM \'de\' y'],
  ['HH:mm', 'HH:mm:ss', 'HH:mm:ss z', 'HH:mm:ss zzzz'],
  ['{1} {0}', u, '{1} \'a\' \'las\' {0}', u],
  ['.', ',', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
  ['#,##0.###', '#,##0 %', '¤ #,##0.00', '#E0'],
  'S/',
  'sol peruano',
  {
    AUD: [u, '$'],
    BRL: [u, 'R$'],
    CAD: [u, '$'],
    CNY: [u, '¥'],
    ESP: ['₧'],
    EUR: [u, '€'],
    FKP: [u, 'FK£'],
    GBP: [u, '£'],
    HKD: [u, '$'],
    ILS: [u, '₪'],
    INR: [u, '₹'],
    JPY: [u, '¥'],
    KRW: [u, '₩'],
    MXN: [u, '$'],
    NZD: [u, '$'],
    PEN: ['S/'],
    RON: [u, 'L'],
    SSP: [u, 'SD£'],
    SYP: [u, 'S£'],
    TWD: [u, 'NT$'],
    USD: [u, '$'],
    VEF: [u, 'BsF'],
    VND: [u, '₫'],
    XAF: [],
    XCD: [u, '$'],
    XOF: []
  },
  'ltr',
  plural
];
